const getLocalStorageDarkMode = () => {
  if (localStorage.getItem('Orcamento:darkMode')) {
    return localStorage.getItem('Orcamento:darkMode') === 'true';
  }
  return false;
};

export default getLocalStorageDarkMode;
